<template>
  <div>
    <v-data-table :headers="headers" hide-actions :items="items">
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs-left">
            <span class="sl_table__label-preview" :style="{ 'background-color': props.item.color, color: props.item.text_color}">
              {{ props.item.name }}
            </span>
          </td>
          <td class="text-xs-center">{{ props.item.color }}</td>
          <td class="text-xs-center">{{ props.item.text_color }}</td>
          <td class="text-xs-right ">
            <div class="table_actions_btns">
              <edit-dialog :label="props.item" @update="refresh">
                <v-btn icon color="success" small :ripple="false"><v-icon size="18">edit</v-icon></v-btn>
              </edit-dialog>
              <remove-dialog :yes="() => remove(props.item)">
                <v-btn color="error" icon small :ripple="false"><v-icon size="18">delete_forever</v-icon></v-btn>
              </remove-dialog>
            </div>
          </td>
        </tr>
      </template>
      <template slot="footer">
        <td :colspan="headers.length - 1"></td>
        <td class="sl_table__footer-td">
          <edit-dialog @update="refresh">
            <v-btn color="success" small block :ripple="false">New tag</v-btn>
          </edit-dialog>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import * as mixins from '@/mixins/'
  import edit from '@/components/projects/labels-edit'

  export default {
    name: 'ProjectsLabels',
    mixins: [mixins.removable, mixins.preloader],
    data() {
      return {
        api: this.$api.labels,
        items: [],
        headers: [
          { text: 'Title', align: 'left', sortable: true, value: 'name' },
          { text: 'Background color', align: 'center', sortable: true, value: 'amount' },
          { text: 'Text color', align: 'center', sortable: true, value: 'date' },
          { text: 'Action', align: 'right', sortable: false },
        ],
      }
    },
    methods: {
      load() {
        let params = {
          project_id: parseInt(this.$route.params.project_id),
          unlimit: 1
        }
        return this.api.list(params).then(response => {
          this.items = response.data.data ? response.data.data : response.data
        })
      },
      refresh() {
        this.queue(this.load())
      },
      remove(item) {
        this.api.delete(item.id).then(response => {
          this.queue(this.load())
        })
      }
    },
    mounted() {
      this.queue(this.load())
    },
    components: {
      'edit-dialog': edit
    }
  }
</script>
